import React from "react";
import { Trans, Select } from "@lingui/macro";
import { ClearRefinements, connectMenu } from "react-instantsearch-dom";

const LangRefinement = connectMenu(({ items, refine }) => {
  return (
    <div
      className="flex justify-left flex-1 mr-2 md:mr-0 md:justify-end xl:text-base"
      id="langRefinement"
    >
      <ClearRefinements
        translations={{
          reset: <Trans>All languages</Trans>,
        }}
        transformItems={(items) =>
          items.filter(({ attribute }) => attribute === "language")
        }
        {...(items.length < 1 && {
          className: "border-b-2 border-brand-primary font-medium text-gray-700",
        })}
      />
      <div className="text-gray-400 md:ml-4">
        {items.map((item) => (
          <button
            key={`lang_filter_${item.label}`}
            onClick={(event) => {
              event.preventDefault();
              refine(item.value);
            }}
            style={{ marginLeft: 10 }}
            {...(item.isRefined && {
              className:
                "border-b-2 border-brand-primary font-medium text-gray-700",
            })}
          >
            <span className="hidden md:inline-block">
              <Select
                value={item.label}
                en="English"
                es="Spanish"
                other="English"
              />
            </span>
            <span className="md:hidden">
              <Select value={item.label} en="EN" es="SP" other="EN" />
            </span>
          </button>
        ))}
      </div>
    </div>
  );
});

export default LangRefinement;
